// extracted by mini-css-extract-plugin
export default {"form-control":"Input_form-control__eJ7pn","label":"Input_label__Os-VI","input":"Input_input__Mv53L","icon":"Input_icon__4-t25"};